import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import CurrencyList from '../../../components/SiteAdmin/Currency/CurrencyList';
import Loader from '../../../components/Common/Loader/Loader';
import { getCurrencyQuery } from '../../../lib/graphql';
import messages from '../../../locale/messages';
import s from './Currency.css';

export class Currency extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { CurrencyData, CurrencyData: { loading } } = this.props;

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    {!loading && <div className={s.container}>
                        <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
                            {formatMessage(messages.currencyList)}
                        </div>
                        <div className={s.paddingRoutesSection}>
                            <CurrencyList CurrencyData={CurrencyData} />
                        </div>
                    </div>}
                </div>
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withStyles(s),
    graphql(getCurrencyQuery, {
        name: 'CurrencyData',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: true
        }
    })
)(Currency);
